const path = 'redux/User';
export const USER_LOGGED_IN = `${path}/USER_LOGGED_IN`;
export const USER_LOGGED_OUT = `${path}/USER_LOGGED_OUT`;
export const TOGGLE_HIDDEN_SIDEBAR = `${path}/TOGGLE_HIDDEN_SIDEBAR`;
export const SET_SIDEBAR_COLLAPSED = `${path}/SET_SIDEBAR_COLLAPSED`;
export const SET_ONBOARDING_STEP = `${path}/SET_ONBOARDING_STEP`;
export const SET_ONBOARDING_COMPLETE = `${path}/SET_ONBOARDING_COMPLETE`;
export const SET_WALKTHROUGH_SEEN = `${path}/SET_WALKTHROUGH_SEEN`;